var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPacketIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9798 3.79883L6.48975 7.50057V15.0002L12.9798 11.2504V3.79883Z",
    fill: "#F0C52C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44199 7.50057L0 3.79883V11.2985L6.44199 14.9521V7.50057Z",
    fill: "#FAD7AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44176 0L12.9799 3.79789L6.44176 7.5477L0.0478516 3.79789L6.44176 0Z",
    fill: "#E2A773"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41316 1.15234L10.24 2.20998L3.798 5.95979L1.9231 4.90216L8.41316 1.15234Z",
    fill: "#C3895C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97095 7.73949V4.95117L3.79778 5.96074V8.46061C3.79778 8.72983 3.50933 8.70098 3.36511 8.65291L2.16325 7.97987C2.00941 7.94141 1.97095 7.80359 1.97095 7.73949Z",
    fill: "#E2A773"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketIcon);
export default __webpack_public_path__ + "static/media/packet-icon.e113a7b0cdafa932225ccd5589c657e3.svg";
export { ForwardRef as ReactComponent };